import { adminFetch } from "./_client";

export interface UsDriverCutoffCase {
  adminNotes: string;
  decision: string;
  recordVersion: number;
  recordHistory: unknown[];
  recordedDecisionAt: string | null;
  recordedDecisionBy: number | null;
  tripId: number;
  createdAt: string | null;
  dueAt: string | null;
  preparedAt: string | null;
  preparedBy: number | string | null;
  decisionAt: string | null;
  decisionBy: number | string | null;
  renterOutcome: string | null;
  renterAmount: number | null;
  renterCurrency: string | null;
  renterReason: string | null;
  hostOutcome: string | null;
  hostAmount: number | null;
  hostCurrency: string | null;
  hostReason: string | null;
  renterStatus: string | null;
  renterFirstFollowUpAt?: string | null;
  renterStatusUpdatedAt?: string | null;
  renterUpdatedAt?: string | null;
  hostStatus: string | null;
  hostFirstFollowUpAt?: string | null;
  hostStatusUpdatedAt?: string | null;
  hostUpdatedAt?: string | null;
  renterLastFollowUpAt?: string | null;
  hostLastFollowUpAt?: string | null;
  isOverdue?: boolean;
  serviceCommitmentOverdue?: boolean;
  capturedPaymentState: string | null;
  depositAuthorizationState: string | null;
  hostPayoutState: string | null;
  dispatchState: string | null;
  dispatchError: string | null;
  exception: string | null;
  originalPayoutStatus?: number | null;
  alreadyPaidAcknowledgedAt?: string | null;
  alreadyPaidAcknowledgedBy?: number | string | null;
  resolvedAt: string | null;
  evidence: unknown;
  recommendation: string | null;
  notes: unknown;
}

export function fetchUsDriverCutoffCases(token: string, offset = 0) {
  return adminFetch<{
    cases: UsDriverCutoffCase[];
    page: { limit: number; offset: number; total: number; nextOffset: number | null };
  }>(`/admin/us-driver-cutoff-cases?limit=100&offset=${offset}`, token);
}

export function fetchUsDriverCutoffCase(token: string, tripId: number) {
  return adminFetch<{ case: UsDriverCutoffCase }>(`/admin/us-driver-cutoff-cases/${tripId}`, token);
}

export function saveUsDriverCutoffRecord(
  token: string, tripId: number,
  body: { expectedVersion: number; adminNotes?: string; decision?: string },
) {
  return adminFetch<{ case: UsDriverCutoffCase }>(`/admin/us-driver-cutoff-cases/${tripId}/record`, token, {
    method: "PATCH", body: JSON.stringify(body),
  });
}
